window.addEventListener('load', function (event) {

    let swiper1;
    initSwiper1();

    let swiper2;
    initSwiper2();

    let swiper3;
    initSwiper3();

    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            destroySwiper1();
            initSwiper1();

            destroySwiper2();
            initSwiper2();

            destroySwiper3();
            initSwiper3();

        } else {
            // console.log('page normal load');            
        }
    });
});

function initSwiper1() {
    swiper1 = new Swiper(".swiper1", {
        direction: 'vertical',
        loop: true,
        slidesPerView: 0.46,
        speed: 10000,
        allowTouchMove: false,
        spaceBetween: 24,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 0.5,
            }
        }
    });
}

function destroySwiper1() {
    if (swiper1) {
        swiper1.destroy(true, true); // "true, true" para destruir e limpar os eventos
    }
}

function initSwiper2() {
    swiper2 = new Swiper(".swiper2", {
        direction: 'vertical',
        loop: true,
        slidesPerView: 0.46,
        speed: 10000,
        allowTouchMove: false,
        spaceBetween: 8,
        autoplay: {
            delay: 0,
            reverseDirection: true,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 0.5,
                spaceBetween: 24,
            }
        }
    });
}

function destroySwiper2() {
    if (swiper2) {
        swiper2.destroy(true, true); // "true, true" para destruir e limpar os eventos
    }
}

function initSwiper3() {
    swiper3 = new Swiper(".swiper3", {
        direction: 'vertical',
        loop: true,
        slidesPerView: 0.46,
        speed: 10000,
        allowTouchMove: false,
        spaceBetween: 24,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 0.5,
            }
        }
    });
}

function destroySwiper3() {
    if (swiper3) {
        swiper3.destroy(true, true); // "true, true" para destruir e limpar os eventos
    }
}